export enum NotificationType {
    INFO = 'INFO',
    SUCCESS = 'SUCCESS',
    ERROR = 'ERROR'
}
